import { number, shape } from 'prop-types';

export default shape({
  age: number.isRequired,
  retirement_age: number,
  monthly_contribution: number.isRequired,
  pension_pot: number.isRequired,
});
